import { Link } from 'react-router'
import type { DiscoverSeason } from '../../../api/compete'
import styles from './home.module.css'

function startsLabel(s: DiscoverSeason, now: Date): string {
  if (s.status === 'active' || s.status === 'playoffs') return 'Live'
  if (!s.starts_at) return 'Date TBD'
  const at = new Date(s.starts_at)
  if (Number.isNaN(at.getTime())) return 'Date TBD'
  return at.getTime() < now.getTime()
    ? 'Started'
    : at.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })
}

/**
 * Competitions open on Carousel right now: proof the place is alive before
 * anyone has an account. Each row opens the competition's public page.
 */
export function OpenCompetitions({ seasons, now }: { seasons: DiscoverSeason[]; now: Date }) {
  return (
    <section aria-labelledby="home-open" className={styles.section} data-panel="Happening on Carousel">
      <div className={styles.sectionHead}>
        <h2 id="home-open" className={styles.sectionTitle}>Happening on Carousel</h2>
        <Link to="/compete" className={styles.sectionLink}>All competitions →</Link>
      </div>
      {seasons.length === 0
        ? <p className={styles.todoDesc}>Nothing open right now. New leagues and tournaments land on Competitions.</p>
        : (
          <ul className={styles.openList}>
            {seasons.map((s) => (
              <li key={s.id}>
                <Link to={`/org/${s.org_slug}/competitions/${s.slug}`} className={styles.openRow}>
                  {s.org_logo_url
                    ? <img src={s.org_logo_url} alt="" className={styles.placeLogo} />
                    : <span className={styles.placeInitial} aria-hidden="true">{s.org_name.slice(0, 1)}</span>}
                  <span className={styles.placeText}>
                    <span className={styles.placeName}>{s.name}</span>
                    <span className={styles.placeRole}>
                      {[s.game_name, s.competition_type === 'tournament' ? 'Tournament' : 'League', s.org_name].join(' · ')}
                    </span>
                  </span>
                  <span className={styles.openMeta}>{startsLabel(s, now)}</span>
                  <span className={styles.openMeta}>
                    {s.registered_teams > 0
                      ? `${s.registered_teams}${s.max_teams ? ` of ${s.max_teams}` : ''} teams`
                      : 'Solo or team'}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
    </section>
  )
}
